/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Scene: {
        $segments: implementRelation({
            kind: 'allOfType',
            target: 'Segment',
            cardinality: '0-N'
        })
    },
    Segment: {
        $scene: implementRelation({
            kind: 'allOfType',
            target: 'Scene',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {
    Scene: {
        noCabinetAtEnds: {
            type: 'noCabinetAtEnds',
            severity: 'warning',
            message: 'Configuration must have a cabinet at both ends.'
        },
        openSpaceMaxLength: {
            type: 'openSpaceMaxLength',
            severity: 'fatal',
            message: 'Open space cannot exceed 4 feet.'
        },
        noOpenSpaceNextToCountertop: {
            type: 'noOpenSpaceNextToCountertop',
            severity: 'fatal',
            message: 'Open space cannot be next to a countertop.'
        },
        countertopSectionMaxLength: {
            type: 'countertopSectionMaxLength',
            severity: 'fatal',
            message: 'A countertop section cannot exceed 16 feet.'
        },
        totalConfigurationMaxLength: {
            type: 'totalConfigurationMaxLength',
            severity: 'fatal',
            message: 'Total width cannot exceed 40 feet.'
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const dataExpressions = implementCustomExpressions({});
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(dataExpressions);

//# sourceMappingURL=implementation.js.map